<div class="d-flex">
  @if (showPreview) {
    <div class="card p-3 w-100">
      <app-signals-preview
        [devicesList]="devicesList"
        [signalMultiDevicesList]="signalMultiDevicesList"
        [signalsData]="signalsData"
        [multiSignalsData]="multiSignalsData"
        (getData)="getPreviewData($event)"
        (closePreview)="closePreview()"
      ></app-signals-preview>
    </div>
  }
  <div class="card p-3 options-signals-container" [ngClass]="{'d-none': showPreview}">
    <div>
      <div class="text-primary font-weight-bold mb-1 h6">
        {{'DATA_STUDIO.DATA_PARAMETERS.TITLE' |translate}}
      </div>
      <div class="text-primary mb-4">
        <span>{{'DATA_STUDIO.DATA_PARAMETERS.LIVE_DATA' |translate}}</span>
      </div>
    </div>
    <div class="d-flex justify-content-between">
      <div class="data-assets-container">
        <div class="text-primary font-weight-bold mb-2">
          {{'DATA_STUDIO.DATA_PARAMETERS.DATA_ASSET' |translate}}
        </div>
        <!--Date Range -->
        <div class="mb-3">
          <div class="d-flex justify-content-between">
            <span class="text-grey">{{'DATA_STUDIO.DATA_PARAMETERS.DATE_RANGE' |translate}}</span>
            @if (wrongDate) {
              <i class="far fa-info-circle text-danger" [matTooltip]="('DATA_STUDIO.DATA_PARAMETERS.CORRECT_DATE' |translate)"></i>
            }
          </div>
          <div>
            <input type="text" class="form-control date-range-picker" name="date-data-studio" #drp="bsDaterangepicker"
              bsDaterangepicker [bsConfig]="bsConfig | async" [(ngModel)]="bsRangeValue" [maxDate]="maxDate" [minDate]="minDate"
              (bsValueChange)="changeDateRange($event)" [class.border-danger]="wrongDate" placement="bottom left">
          </div>
        </div>
        <!--Aggregation Method -->
        <div class="mb-3">
          <div class="d-flex justify-content-between">
            <span class="text-grey">{{'DATA_STUDIO.DATA_PARAMETERS.AGGREGATION_METHOD' |translate}}</span>
          </div>
          <lib-select
            id="data-live-data-select-aggregation"
            [options]="aggregationOptions.titles"
            [label]="selectedAggregationName"
            [border]="'custom-border'"
            [classes]="'font-size-normal-small text-primary h-100'"
            [notBold]="true"
            [fullWidth]="true"
            [itemClasses]="'font-size-normal-small'"
            [container]="''"
            (selectedChanged)="selectAggregation($event)">
          </lib-select>
        </div>
        <!--Turbine Type -->
        @if (turbineTypeAggregation) {
          <div class="mb-3">
            <div class="d-flex justify-content-between">
              <span class="text-grey">{{'DATA_STUDIO.DATA_PARAMETERS.TURBINE_TYPE' |translate}}</span>
            </div>
            <lib-select
              id="data-live-data-select-turbine-type"
              [options]="turbineTypes"
              [label]="turbineTypeSelection"
              [border]="'custom-border'"
              [classes]="'font-size-normal-small text-primary h-100'"
              [notBold]="true"
              [fullWidth]="true"
              [itemClasses]="'font-size-normal-small'"
              [doNotTranslate]="true"
              [container]="''"
              (selectedChanged)="selectTurbineType($event)">
            </lib-select>
          </div>
        }
        <!--Select Park -->
        @if (parkAggregation || turbineAggregation) {
          <div class="mb-3">
            <div class="d-flex justify-content-between">
              <span class="text-grey">{{'DATA_STUDIO.DATA_PARAMETERS.SELECT_PARK' |translate}}</span>
            </div>
            @if (dataParks) {
              <lib-select
                id="data-live-data-select-park"
                [options]="dataParksNames"
                [label]="parkSelected?.fe_name"
                [border]="'custom-border'"
                [classes]="'font-size-normal-small text-primary h-100'"
                [notBold]="true"
                [fullWidth]="true"
                [itemClasses]="'font-size-normal-small'"
                [doNotTranslate]="true"
                [container]="''"
                (selectedChanged)="selectPark($event)">
              </lib-select>
            }
          </div>
        }
        <!-- Select type -->
        @if (parkAggregation) {
          <div class="mb-3">
            <div class="d-flex justify-content-between">
              <span class="text-grey">{{'DATA_STUDIO.DATA_PARAMETERS.SELECT_TYPE' |translate}}</span>
            </div>
            <lib-select
              id="data-live-data-select-park"
              [options]="typesOptions.titles"
              [label]="selectedTypeName"
              [border]="'custom-border'"
              [classes]="'font-size-normal-small text-primary h-100'"
              [notBold]="true"
              [fullWidth]="true"
              [itemClasses]="'font-size-normal-small'"
              [container]="''"
              [disabled]="!parkSelected?.controlSystem?.length && !parkSelected?.metmasts?.length"
              (selectedChanged)="selectType($event)">
            </lib-select>
          </div>
        }
        <!--Select Turbines -->
        @if (parkAggregation && parkSelected && turbineView) {
          <div class="mb-3">
            <div class="d-flex justify-content-between">
              <span class="text-grey">{{'DATA_STUDIO.DATA_PARAMETERS.SELECT_TURBINES' |translate}}</span>
            </div>
            <app-data-assets [park]="parkSelected" [aggregationMethod]="'park'"
              (selectedParksTurbines)="selectedAssetTurbines($event)">
            </app-data-assets>
          </div>
        }
        <!-- Select Control System -->
        @if (parkAggregation && parkSelected && controlSystemView) {
          <div class="mb-3">
            <div class="d-flex justify-content-between">
              <span class="text-grey">{{'DATA_STUDIO.DATA_PARAMETERS.SELECT_DEVICES' |translate}}</span>
            </div>
            <app-data-unified-items
              [items]="parkSelected.controlSystem"
              [disabled]="disabled"
              (selectedItems)="selectedAssetControlSystem($event)"
              [title]="parkSelected.name">
            </app-data-unified-items>
          </div>
        }
        <!-- Select Metmast -->
        @if (parkAggregation && parkSelected && metmastView) {
          <div class="mb-3">
            <div class="d-flex justify-content-between">
              <span class="text-grey">{{'DATA_STUDIO.DATA_PARAMETERS.SELECT_DEVICES' |translate}}</span>
            </div>
            <app-data-unified-items
              [items]="parkSelected.metmasts"
              [disabled]="disabled"
              (selectedItems)="selectedAssetMetmasts($event)"
              [title]="parkSelected.name">
            </app-data-unified-items>
          </div>
        }
        <!--Select One Turbine -->
        @if (turbineAggregation) {
          <div class="mb-3">
            <div class="d-flex justify-content-between">
              <span class="text-grey">{{'DATA_STUDIO.DATA_PARAMETERS.SELECT_TURBINE' |translate}}</span>
            </div>
            <lib-select
              id="data-live-data-select-one-turbine"
              [options]="turbinesList"
              [label]="turbineSelection"
              [border]="'custom-border'"
              [classes]="'font-size-normal-small text-primary h-100'"
              [notBold]="true"
              [fullWidth]="true"
              [itemClasses]="'font-size-normal-small'"
              [doNotTranslate]="true"
              [container]="''"
              (selectedChanged)="selectedOneTurbine($event)">
            </lib-select>
          </div>
        }
        <!--Select Assets -->
        @if (turbineTypeAggregation && turbineType) {
          <div class="mb-3">
            <div class="d-flex justify-content-between">
              <span class="text-grey">{{'DATA_STUDIO.DATA_PARAMETERS.SELECT_ASSETS' |translate}}</span>
            </div>
            <div class="d-flex select-assets-container justify-content-between mb-2">
              <div class="w-100 mr-2">
                @if (dataParks) {
                  <lib-select
                    id="data-live-data-select-park-asset"
                    [options]="assetParksNames"
                    [label]="parkNameSelected || ('DATA_STUDIO.DATA_PARAMETERS.SELECT_PARK_TO_ADD' | translate)"
                    [border]="'custom-border'"
                    [classes]="'font-size-normal-small text-primary h-100'"
                    [notBold]="true"
                    [fullWidth]="true"
                    [itemClasses]="'font-size-normal-small'"
                    [doNotTranslate]="true"
                    [container]="''"
                    (selectedChanged)="selectParkAsset($event)">
                  </lib-select>
                }
              </div>
              <lib-button
                id="data-live-data-btn-add-park"
                [disabled]="!parkNameSelected"
                [label]="'DATA_STUDIO.DATA_PARAMETERS.ADD_PARK' |translate"
                (buttonClicked)="addPark()" >
              </lib-button>
            </div>
            @if (assetParkTurbinesSelected.length > 0) {
              <div>
                @for (parkItem of assetParkTurbinesSelected; track $index) {
                  <div>
                    <app-data-assets [park]="parkItem" (selectedParksTurbines)="selectedAssetTurbines($event)"
                      (removeParkList)="removeParkList($event)">
                    </app-data-assets>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
      @if (turbineView) {
        <div class="available-signals-container">
          <app-turbines-signals
            [signalTypesMapper]="signalTypesMapper"
            [turbineSignals]="turbinesSignals"
            (changeSignalsSelection)="getSelectedTurbineSignals($event)"
          ></app-turbines-signals>
        </div>
      }
      @if (controlSystemView) {
        <div class="w-100">
          <app-control-system-signals
            [signals]="controlSystemSignals"
            (changeSignalsSelection)="getSelectedCSSignals($event)"
          ></app-control-system-signals>
        </div>
      }
      @if (metmastView) {
        <div class="w-100">
          <app-metmasts-signals
            [metmasts]="metmastsSignals"
            (changeSignalsSelection)="getSelectedMetmastSignals($event)"
          ></app-metmasts-signals>
        </div>
      }
    </div>
  </div>
  <div class="ml-2 file-summary-container">
    <div class="card p-3">
      <app-data-file-summary
        [selectedPage]="2"
        [(isPreviewSelected)]="showPreview">
      </app-data-file-summary>
    </div>
    <div class="card p-3 mt-3">
      <app-data-files [type]="'live'"></app-data-files>
    </div>
  </div>
</div>